import { render } from "./PrintBalanceTile.vue?vue&type=template&id=89f0c6d2"
import script from "./PrintBalanceTile.vue?vue&type=script&lang=js"
export * from "./PrintBalanceTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__